import "twin.macro";
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PopupProduct from "./PopupPortfolio";
import { useRef, useEffect } from "react";
import { useDetectOutsideClick } from "./useDetectOutsideClick";

const PortfolioCard = (data) => {
  const { title, image, content } = data;
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useDetectOutsideClick(dropdownRef, false);
  const img = getImage(image);

  useEffect(() => {
    console.log(isOpen);
  }, [isOpen]);

  return (
    <>
      <div
        className="group"
        tw="grid rounded-2xl border-2 border-red-600 p-5 space-y-2"
      >
        <GatsbyImage
          tw="rounded-2xl h-auto w-full shadow-2xl group-hover:(px-0!)"
          image={img}
          alt="profile"
        />
        <p tw="font-medium text-center text-2xl">{title}</p>
        <p>{content}</p>

        <button
          onClick={() => setIsOpen(true)}
          tw="place-self-end transition-all duration-200 focus:outline-none rounded-2xl border-2 border-red-600 px-5 py-3 w-full hover:(border-white bg-red-600)"
        >
          View Details
        </button>
        <PopupProduct
          isOpen={isOpen}
          data={data}
          setIsOpen={setIsOpen}
          dropdownRef={dropdownRef}
        />
      </div>
    </>
  );
};

export default PortfolioCard;
